import React from 'react';
import {Flex, SVGButton} from '/app/src/component';
import SummaryRow from '../SummaryRow';
import BackBtn from '../BackBtn';
import NextBtn from '../NextBtn';
import DotProgress from '../DotProgress'

const buttonStyle = {
    backgroundHover: 'LightBlue1',
    height: '40px',
    hover: 'JibberBlue_M',
    color: 'MediumGray5'
}
const titleTextStyle = {
    fontSize: '25px',
    paddingLeft: '50px',
    color: 'DarkGray',
    fontWeight: 300,
    vAlignContent: 'center',
    marginRight: '25px'
}
const periodConfigStyle = {
    padding: '20px'
}
const summaryContainer = {
    backgroundColor: 'LightGray2'
}
const summaryTitle = {
    fontSize: '25px',
    fontWeight: 300,
    hAlignContent: 'center',
    margin: '20px 0px',
}

const summaryTexts = {
    padding: '0 50px'
}

const summaryColumn = {
    width: '55%'
}
const hrStyle = {
    width: '80%',
    borderWidth: '2px',
    margin: '15px 0px',
    borderLeft: 'none'
}

const dotProgressStyle = {
    paddingBottom: '10px',
    hAlignContent: 'center'
}

class OverviewPage extends React.Component {
    render() {
        const {
            period,
            handleButtonClick,
            backButtonClick,
            nextButtonClick,
            companyName,
            email,
            orgNbr,
            address,
            city,
            postalCode,
            plan,
            subscription,
            nbrEmployees,
            translatePlan,
            calculateTotal
        } = this.props

        const total = calculateTotal(plan, subscription)
        const discount = calculateTotal(plan, 'monthly') - total
        return (
            <Flex column grow>
                <Flex {...periodConfigStyle}>
                    <Flex {...titleTextStyle}>
                        Faktureringsperiod
                    </Flex>
                    <Flex>
                        <SVGButton
                            active={period === 'monthly'}
                            border
                            text='Månadsvis'
                            onClick={() => handleButtonClick('monthlyPeriodBtn')}
                            {...buttonStyle}/>
                        <SVGButton
                            active={period === 'quarterly'}
                            marginLeft='16px'
                            border
                            onClick={() => handleButtonClick('quarterlyPeriodBtn')}
                            text='Kvartalsvis'
                            {...buttonStyle}/>
                    </Flex>
                </Flex>
                <Flex {...summaryContainer} column grow>
                    <Flex {...summaryTitle}>
                        Översikt
                    </Flex>
                    <Flex {...summaryTexts} grow>
                        <Flex {...summaryColumn} column>
                            <SummaryRow title={'Faktureringsuppgifter:'}
                                infoList={[orgNbr, companyName]}/>
                            <SummaryRow title={'Adress:'}
                                infoList={[address, postalCode + ' ' + city, city]}/>
                            <SummaryRow title={'E-post:'}
                                infoList={[email]}/>
                        </Flex>
                        <Flex column grow>
                            <SummaryRow title={'Användare:'}
                                infoList={[nbrEmployees + 'x']}
                                textAlign='right'/>
                            <SummaryRow title={'Prisplan:'}
                                infoList={[translatePlan(plan)]}
                                textAlign='right'/>
                            <SummaryRow title='Avtal:'
                                infoList={[translatePlan(subscription)]}
                                textAlign='right'/>
                            <SummaryRow title='Fakturering:'
                                infoList={[translatePlan(period)]}
                                textAlign='right'/>
                            <Flex color='#4E4E4E' hAlignContent='right'>
                                <hr style={hrStyle}/>
                            </Flex>
                            <SummaryRow title='Total:'
                                infoList={[`${total}:-/månad`]}
                                textAlign='right'
                                emphasize={true}/>
                            { discount > 0 && <SummaryRow title='Rabatt:'
                                infoList={[`${discount}:-`]}
                                textAlign='right'
                                textColor='JibberBlue_M'
                                emphasize={true}/>}
                        </Flex>
                    </Flex>
                    <Flex>
                        <Flex width='33.33%'>
                            <BackBtn onClick={backButtonClick} text='Tillbaka'/>
                        </Flex>
                        <Flex width='33.33%' hAlignContent='center'>
                            <NextBtn
                                onClick={nextButtonClick}
                                text='Bekräfta Köp'
                                top
                                fineText='Du kommer att loggas ut och sedan ha omedelbar tillgång till funktionerna.'/>
                        </Flex>
                    </Flex>
                    <Flex {...dotProgressStyle}>
                        <DotProgress currentPage={2}/>
                    </Flex>
                </Flex>
            </Flex>
        )
    }
}

export default OverviewPage



// WEBPACK FOOTER //
// ./src/component/Modal/PaymentModal/Pages/OverviewPage.js